import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-router-outlet',
    templateUrl: './router-outlet.component.html',
    styleUrls: ['./router-outlet.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RouterOutletComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {

  }

}
